<template>
  <filter-bar>
    <!-- <div v-if="false" class="md-layout-item md-medium-size-50 md-small-size-50 md-xsmall-size-100">
      <md-field>
        <label for="dateFrom">
          <md-icon>calendar_today</md-icon>
          <span v-show="!dateFrom">Desde</span>
        </label>
        <datetime
          input-style="border: none; outline:none; width: 100%"
          type="date"
          title="Desde"
          value-zone="America/Mexico_City"
          v-model="dateFrom"
          :phrases="{ ok: '', cancel: '' }"
          auto
        ></datetime>
        <md-button class="md-simple md-just-icon" @click="dateFrom = null">
          <md-icon>close</md-icon>
        </md-button>
      </md-field>
    </div>
    <div
      v-if="false"
      class="md-layout-item md-size-20 md-medium-size-50 md-small-size-50 md-xsmall-size-100"
    >
      <md-field>
        <label for="dateOccurred">
          <md-icon>calendar_today</md-icon>
          {{ dateTo ? "" : "Hasta" }}
        </label>
        <datetime
          input-style="border: none; outline:none; width: 100%"
          type="date"
          title="Hasta"
          value-zone="America/Mexico_City"
          v-model="dateTo"
          :phrases="{ ok: '', cancel: '' }"
          auto
        ></datetime>
        <md-button class="md-simple md-just-icon" @click="dateTo = null">
          <md-icon>close</md-icon>
        </md-button>
      </md-field>
    </div>-->
    <div class="md-layout-item md-size-20 md-medium-size-50 md-small-size-50 md-xsmall-size-100">
      <md-field>
        <label>Almacén</label>
        <md-select v-model="selectedWarehouse">
          <md-option
            v-for="camp in fetchedWarehouses"
            :key="camp.id"
            :value="camp.id"
          >{{ camp.name }}</md-option>
        </md-select>
      </md-field>
    </div>
  </filter-bar>
</template>

<script>
import { Slider } from "@/components";
import FilterBar from "@/components/FilterBar";

import moment from "moment";
import warehouseService from "@/services/purchase/warehouse";

export default {
  name: "InvetoryLogFilters",
  components: {
    Slider,
    FilterBar,
  },
  props: {
    defaults: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const { dateFrom, dateTo } = this.defaults;
    return {
      dateFrom:
        dateFrom === undefined
          ? moment().subtract(15, "days").format("YYYY-MM-DD")
          : dateFrom,
      dateTo: dateTo === undefined ? moment().format("YYYY-MM-DD") : dateTo,
      loading: false,
      fetchedWarehouses: [],
      selectedWarehouse: null,
    };
  },
  watch: {
    defaults(value) {
      const { dateFrom, dateTo } = value;
      this.dateFrom =
        dateFrom === undefined
          ? moment().subtract(15, "days").format("YYYY-MM-DD")
          : dateFrom;
      this.dateTo = dateTo;
    },
    dateFrom(value) {
      this.$emit("updateDateFrom", value || null);
    },
    dateTo(value) {
      this.$emit("updateDateTo", value || null);
    },
    selectedWarehouse(value) {
      this.$emit("updateSelectedWarehouse", value || null);
    },
  },
  created() {
    this.loading = true;
    warehouseService
      .fetchiWarehouse()
      .then((warehouses) => {
        this.fetchedWarehouses = warehouses;
        this.selectedWarehouse = 1;
      })
      .catch(this.$fireErrorResponse)
      .finally(() => (this.loading = false));
  },
};
</script>

<style lang="scss" scoped>
.md-card-content:last-of-type {
  padding-bottom: 0px;
}

.md-card .md-card-content {
  padding: 0px 15px;
  line-height: 1.75em;
  position: relative;
}

.md-field.md-focused label,
.md-field.md-has-value label,
.md-field.md-focused.md-has-value label {
  color: #6d6d6dab !important;
  font-weight: bold;
  font-size: 1.4rem;
}

.md-field.md-focused label,
.md-field.md-field.md-has-value label {
  top: -1rem;
}

.vdatetime {
  margin-left: 2em;
  margin-top: 1.1em;
  width: 100%;
}

.before-list-item {
  font-size: 1.6rem;
  padding: 8px 0px 8px 10px;
}
.before-list-item:hover {
  cursor: pointer !important;
  background-color: red;
  font-weight: bold;
  color: white;
}

.date-label {
  top: -9px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Reports/InventoryLog/Filter.vue